module.exports = __webpack_public_path__ + "img/zt_banner_img.9ad68763.png";